import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Self-assessment and personal results are PDMA-only (OM.1); non-PDMA users go home. */
export const pdmaMemberGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  if (authService.user()?.isPdmaMember !== false) {
    return true;
  }
  return inject(Router).createUrlTree(['/']);
};
